<div class="label">
  <div {{#if theme_class}}class="label label__theme--{{theme_class}}"{{/if}}>
    <label class="label__text {{#if text_class}}{{text_class}}{{/if}}"
      tabindex="0" aria-label="{{t prefix}}{{t description}}">
        {{t prefix}}{{t description}}
    </label>
  </div>
</div>
